module.exports = __webpack_public_path__ + "media/images/icons/non-smartfone-3b7e014f944de6ed150cb0bd32338c61.png";